<template>
    <template v-if="isActive">
        <div class="mvt-searchfilter" ref="searchFilter" :class="{'mode-sale': isSale, 'mode-sold': isSold, 'mode-rent': isRent, 'mode-focus': isFocusMode, 'wide': wide}" :comp="$options.name" data-role="overlay">
            <div class="mvt-searchfilter-header flex">
                <button type="button" @click="close"><i class="icon-times f4"></i></button>
                <button class="btn small primary" type="button" @click="saveSearch">
                    {{ molang('search.filter.saveSearch') }}
                </button>
            </div>
            <div class="mvt-searchfilter-body grid xs-grid-cols-1 top gap-3">
                <button type="button" class="mvt-searchfilter-close" @click="close"><i class="icon-times"></i></button>
                <ul class="tab tab-bookmark center small">
                    <li><button type="button" @click="switchIndex(0)" :class="isSale ? 'active': ''">{{ molang('search.filter.tabs.forSale') }}</button></li>
                    <li><button type="button" @click="switchIndex(1)" :class="isRent ? 'active': ''">{{ molang('search.filter.tabs.forRent') }}</button></li>
                    <li><button type="button" @click="switchIndex(2)" :class="isSold ? 'active': ''">{{ molang('search.filter.tabs.sold') }}</button></li>
                </ul>
                <template v-for="item in searchFilterData">
                    <div :id="item.id" class="grid xs-grid-cols-1 gap-1 mvt-searchfilter-item" :class="{'focused': focusIds.includes(item.id), 'grouped': focusIds.length>1}">
                        <div class="sub f7 text-gray" v-if="item.subTitle">{{item.subTitle}}</div>
                        <div class="filter-title">
                            <span class="text-bold">{{ getTitle(item) }}</span>
                        </div>
                        <component
                            class="small"
                            :order="item.order"
                            :is="item.type"
                            :label="item.label"
                            :data="item.data"
                            :disabled="item.disabled"
                            :theme="item.theme"
                            v-model="filterModel[item.model]"
                            :options="filterFieldOptions(item)"
                        />
                    </div>
                </template>
                <slot></slot>
            </div>
            <div class="mvt-searchfilter-footer grid xs-grid-cols-2">
                <button class="btn secondary small" type="button" @click="resetFilter">{{ molang('search.moreFilter.reset') }}</button>
                <button class="btn small primary" type="button" @click="applyFilter">
                    {{ molang('search.moreFilter.apply') }} <span v-if="resultCount > 0">({{resultCount}})</span>
                </button>
            </div>
        </div>
        <div class="mvt-searchfilter-overlay" @click="close"></div>
    </template>
</template>
<script src="./mvt-searchfilter.js"></script>
<style lang="scss">
@use "./mvt-searchfilter.scss" as *;
</style>
